// extracted by mini-css-extract-plugin
module.exports = {"strip":"_2S9p1"};